import {
  AssetIcon,
  HomeIcon,
  UserIcon,
  WalletIcon,
} from 'app/shared/componentsRestyled/coreDesignSystem/icons';

export const ICON_SIZE_SM = 14;
export const ICON_SIZE_MD = 16;

/** @enum {string} */
const LinkEntityType = {
  BORROWER: 'borrowers',
  INCOME: 'incomes',
  ASSET: 'assets',
  PROPERTY: 'properties',
  LIABILITY: 'liabilities',
};

/**
 * Display config for each entity-type group in the Links tab.
 * colorName maps to a SYSTEM_COLORS entry (Azure = borrower, Fern = income, Violet = asset,
 * Amber = property, Rose = liability).
 * Rendered in this order.
 */
export const LINK_ENTITY_TYPE_CONFIG = [
  {
    type: LinkEntityType.BORROWER,
    label: 'Borrower',
    editLabel: 'Borrower',
    emptyLabel: 'Link a borrower to this document…',
    colorName: 'Azure',
    Icon: UserIcon,
  },
  {
    type: LinkEntityType.INCOME,
    label: 'Income',
    editLabel: 'Income · add multiple',
    emptyLabel: 'Link an income source to this document…',
    colorName: 'Fern',
    Icon: WalletIcon,
  },
  {
    type: LinkEntityType.ASSET,
    label: 'Asset',
    editLabel: 'Asset',
    emptyLabel: 'Link an asset to this document…',
    colorName: 'Violet',
    Icon: AssetIcon,
  },
  {
    type: LinkEntityType.PROPERTY,
    label: 'Property',
    editLabel: 'Property',
    emptyLabel: 'Link a property to this document…',
    colorName: 'Amber',
    Icon: HomeIcon,
  },
  {
    type: LinkEntityType.LIABILITY,
    label: 'Liability',
    editLabel: 'Liability',
    emptyLabel: 'Link a liability to this document…',
    colorName: 'Rose',
    Icon: WalletIcon,
  },
];
